// Plantillas de mail del "Escribir" del Radar Comercial — docs/decisiones/2026-09-26-radar-mail-
// pagina-diseno.md §12/§13. Español neutro latinoamericano en TÚ ("tienes", no "tenés"): las leen
// clientes chilenos y peruanos por igual.
//
// Devuelven HTML en párrafos — el cuerpo final lo termina de envolver `radar-borrador` (Trebuchet
// MS/#073763/font-size:small) y le agrega la firma real de Gmail del vendedor. Por eso esta
// plantilla YA NO lleva `{firma}` ni `{marca}` (existían cuando el borrador se abría por link, sin
// firma real — ver EscribirRadarModal.js para las dos vías descartadas).
//
// `{frase_red}` (desglose de la red por estado — `getConteoRedPorEstado`, junto a
// `getEdificiosOperativos`) es TODO o NADA: si falta `nEntonces` (edificiosTotales de la venta de
// referencia) o el desglose de hoy no cargó, la frase se omite entera — nunca sale un número flojo
// hacia un cliente. Los tramos en 0 (instalación/piloto) se omiten de la lista, nunca "0 en piloto".
//
// `{frase_agencia}` — solo al CLIENTE, y solo si la empresa tiene contactos de agencia con email
// (nunca nombra a la agencia).

const primerNombre = (nombreCompleto) => (nombreCompleto || "").trim().split(/\s+/)[0] || "";

const construirFraseRed = ({ nEntonces, conteoRed }) => {
  if (nEntonces == null || !conteoRed) return "";
  const { operativos, instalacion, piloto } = conteoRed;

  const partes = [];
  if (operativos > 0) partes.push(`${operativos} operativos`);
  if (instalacion > 0) partes.push(`${instalacion} en instalación`);
  if (piloto > 0) partes.push(`${piloto} en piloto próximos a aprobarse`);

  if (partes.length === 0) return `El año pasado la red tenía ${nEntonces} edificios.`;
  const listaHoy = partes.length > 1 ? `${partes.slice(0, -1).join(", ")} y ${partes.at(-1)}` : partes[0];
  return `El año pasado la red tenía ${nEntonces} edificios; hoy tiene ${listaHoy}.`;
};

const FRASE_AGENCIA_PARALELO =
  "En paralelo le escribí a tu agencia; me encantaría presentarles la propuesta a los dos.";

/**
 * Arma asunto + cuerpo HTML del mail del Radar.
 * @param {{lado:'cliente'|'agencia', tipo:'compro'|'propuso', empresa:string, campana:string|null,
 *   mes:string, nEntonces:number|null, conteoRed:{operativos:number,instalacion:number,piloto:number}|null,
 *   nombreContacto?:string, hayAgenciaConEmail?:boolean}} datos
 * @returns {{asunto:string, cuerpoHtml:string}}
 */
export const armarMailRadar = ({
  lado,
  tipo,
  empresa,
  campana,
  mes,
  nEntonces,
  conteoRed,
  nombreContacto,
  hayAgenciaConEmail,
}) => {
  const campanaTxt = campana || "una campaña";
  const nombre = primerNombre(nombreContacto);
  const saludo = nombre ? `Hola ${nombre},` : "Hola,";
  const fraseRed = construirFraseRed({ nEntonces, conteoRed });
  const sufijoRed = fraseRed ? ` ${fraseRed}` : "";

  const parrafos = [saludo];

  if (lado === "cliente") {
    parrafos.push(
      tipo === "compro"
        ? `En ${mes} del año pasado hicimos juntos ${campanaTxt}.${sufijoRed}`
        : `En ${mes} del año pasado te presentamos ${campanaTxt} y quedó sin concretarse.${sufijoRed} Creo que vale la pena volver a mirarla.`
    );
    if (hayAgenciaConEmail) parrafos.push(FRASE_AGENCIA_PARALELO);
    parrafos.push("¿Tienes un espacio en la agenda de los próximos días para revisarlo?");
  } else {
    parrafos.push(
      tipo === "compro"
        ? `En ${mes} del año pasado salimos con ${campanaTxt} de ${empresa}.${sufijoRed}`
        : `En ${mes} del año pasado te propusimos ${campanaTxt} para ${empresa} y quedó fuera del plan.${sufijoRed}`,
      `¿Nos juntamos la semana que viene para revisar oportunidades de ${empresa}?`
    );
  }

  return {
    asunto: `${empresa} · ${campanaTxt} · ${mes}`,
    cuerpoHtml: parrafos.map((p) => `<p>${p}</p>`).join(""),
  };
};
